import React from 'react';

const Label = ({ label = null, required = false, htmlFor = null }) => {

    const renderRequired = () => {
        if (required !== true) {
            return null;
        }

        return (
            <span className="text-danger user-select-none">*</span>
        );
    }

    if (!label) {
        return null;
    }

    if (!htmlFor) {
        return (
            <div className="mb-1 user-select-none">
                {label+" "}
                {renderRequired()}
            </div>
        )
    }

    return (
        <label className="mb-1 user-select-none" htmlFor={htmlFor}>
            {label+" "}
            {renderRequired()}
        </label>
    );
}

export default Label;
